export enum OfferFormInformationTypeEnum {
  Boolean = 'BOOLEAN',
  BooleanWithValueList = 'BOOLEAN_WITH_VALUE_LIST',
  Description = 'DESCRIPTION',
  Distance = 'DISTANCE',
  Percent = 'PERCENT',
  Price = 'PRICE',
  TravelElement = 'TRAVEL_OFFER_ELEMENT',
  Url = 'URL',
  Value = 'VALUE',
  ValueList = 'VALUE_LIST',
}
